<dynamic-template *ngIf="htmlContent" [content]="htmlContent"></dynamic-template>